<template>
    <div component="Page_404" template="page">
        <div class="bg">
            <h1>404 Page not found</h1>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Page_404',
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Page_404'] {
    .bg {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    h1 {
        width: 100%;
        text-align: center;
    }
}
</style>
